import { SatelliteWebLandlordPropertyHandler_search } from '@zg-rentals/ts-satellite-client';
import type { SatelliteWebLandlordPropertySearchRequestDto } from '@zg-rentals/ts-satellite-client';

/**
 * Shared infinite query options for property search.
 * Used by usePropertyFilter (full property selector) and useHasProperties (lightweight ownership check)
 * so React Query deduplicates the underlying network request.
 */
export default function getPropertySearchQueryOptions(searchText = '') {
  return {
    queryKey: ['propertySearch', searchText],
    queryFn: async ({ pageParam }: { pageParam: string | undefined }) => {
      const requestData: SatelliteWebLandlordPropertySearchRequestDto = {
        startKeyExclusive: pageParam,
      };

      if (searchText) {
        requestData.searchText = searchText;
      }

      return SatelliteWebLandlordPropertyHandler_search(requestData);
    },
    getNextPageParam: (lastPage: Awaited<ReturnType<typeof SatelliteWebLandlordPropertyHandler_search>>) => {
      return lastPage?.pager?.hasMore ? lastPage.pager.endKey : undefined;
    },
    initialPageParam: undefined as string | undefined,
  };
}
